import ShopNavbar from "../../../components/shop/ShopNavbar";
import ShopFooter from "../../../components/shop/ShopFooter";
import { Link } from "react-router-dom";
import ArticleImg from "../../../images/imgs/blog/blog-details-01.png";
import Author from "../../../images/imgs/blog/blog-meta.png";
import Date from "../../../images/svg/date-range.svg";
import Comments from "../../../images/svg/comments.svg";
import Eye from "../../../images/svg/eye.svg";
import { Helmet } from "react-helmet";
import {
  B1Img1,
  B1Img2,
  B1Img3,
  B1Img4,
  B1Img5,
  ChronicDiseasesIntro,
} from "../images";

const ChronicDiseases = () => {
  return (
    <div className="single-blog-page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Adam Superfoods | Chronic diseases and the secret behind them - Pharma
          and Disease Diseases
        </title>
      </Helmet>
      <ShopNavbar />
      <section
        className="single-blog-intro"
        style={{ backgroundImage: `url(${ChronicDiseasesIntro})` }}
      >
        <div className="overlay"></div>
        <div className="rec"></div>
        <div className="rec rec-bottom"></div>
        <div className="container">
          <div className="blog-intro-container">
            <div className="page-navigation">
              <Link to="/shop">Home</Link>
              <span>/</span>
              <span className="blog-details">Blog Details</span>
            </div>
            <h1 className="blog-title">
              حقيقة الأمراض المزمنة والسر خلفها – البيج فارما وتجارة الأمراض
            </h1>
          </div>
        </div>
      </section>
      <main className="content">
        <div className="article-img">
          <div className="overlay"></div>
          <img className="thum-img" src={ArticleImg} alt="" />
          <div className="article-details">
            <div className="author-img-box">
              <img className="author-img" src={Author} alt="" />
              <h6>Mahmoud Adam</h6>
            </div>
            <div className="date-box">
              <img src={Date} alt="" />
              <h6>APR 24, 2025</h6>
            </div>
            <div className="comments-box">
              <img src={Comments} alt="" />
              <h6> (0) COMMENTS</h6>
            </div>
            <div className="views-box">
              <img src={Eye} alt="" />
              <h6>1,526 VIEWERS</h6>
            </div>
          </div>
        </div>
        <article dir="rtl" className="body">
          <h2>
            حقيقة الأمراض المزمنة والسر خلفها – البيج فارما وتجارة الأمراض
          </h2>
          <p>
            لقد جلب لنا القرنين العشرون والحادي والعشرون تحديات صحية غير مسبوقة.
            فعلى الرغم من التقدم الطبي الغير مسبوق، إلا اننا نري وبوضوح ان
            معدلات الصحة العامة في تدهور مستمر. اليوم، لنجد اليوم أن الغالبية
            العظمي من البشر يعانون من العديد من المشاكل الصحية المزمنة مثل
            السمنة، وارتفاع ضغط الدم، ومرض السكري، والضعف العام والأنيميا،
            والتهابات القولون والمفاصل، وضعف البصر الذي لم يعد مقتصرا علي
            المسنين بل وطال أغلب اطفالنا، وهشاشة العظام، وأمراض المناعة وغيرها
            الكثير من الأمراض التي تجر بعضها بعضاً. هذا وبالإضافة إلى ما يشهده
            العالم من انتشار مخيف غير مسبوق للسرطانات، حني أصبحت الأمراض المزمنة
            ظاهرة شائعة تؤثر على جميع الأعمار والخلفيات.
          </p>
          <div className="block-2">
            <div className="b-1">
              <p>
                وفي مشهد متناقض يثير التعجب عندما تتابع مدي تطور القدرات الطبية
                وتجد انه بأرض الواقع قد تضاعفت معدلات السمنة أكثر من ثلاث مرات
                منذ السبعينيات، وطال مرض السكري بنوعيه الآن نحو 40% من سكان
                العالم. ولا تزال أمراض القلب والأوعية الدموية السبب الرئيسي
                للوفاة على مستوى العالم، في حين أن السرطان يحصد أرواح الملايين
                سنويًا. لذا هنا يجب ان نعيد النظر علي كامل الصورة بتفاصيلها
                لنعرف من المستفيد من تضليلنا واقناعنا بهذا التناقض، بل وتلميعه
                بأعيننا.
              </p>
              <h2 className="secondary">عيوب المنهج الطبي التقليدي</h2>
              <p>
                لسنوات طويلة، كنا نعالج الأمراض المزمنة بأدوية وعقاقير طبية لا
                تخفف سوي من أعراض المرض بشكل مؤقت ولكنها لا تساهم بمعالجته بشكل
                كامل ولا حتى تقترب من حل الأسباب الجذرية للمرض، وأصبحنا لم نملك
                سوي التأقلم مع الوضع. فعلى سبيل المثال، يعتمد مريض السكري على
                الأنسولين لخفض مستويات السكر في الدم، ليقدم لنفسه حلاً مؤقتًا،
                وما ان ترتفع تلك النسبة مرة اخري الا ويجد نفسه مضطر لتناول جرعة
                اخري من الانسولين، وأصبح عليه ان يكمل باقي حياته معتمداً علي
                الأنسولين من مصدر خارجي وبالمثل، يتناول مرضي ضغط الدم المرتفع
                للعديد الأدوية مدى الحياة لتقوم بضبط ضغط الدم عند ارتفاعه.
              </p>
            </div>
            <div className="b-2">
              <img src={B1Img1} alt="img" />
            </div>
          </div>
          <p>
            ولكن يجب ان نسأل هنا سؤال هام وبديهي: أليست هكذا مثلها مثل المسكنات؟
            ولماذا ليس هناك أي عقار صيدلاني يقوم بعلاج المرض من جذوه بشكل كامل؟
            ولماذا لا نبحث حول أسباب المشكلة الأساسية المتسببة بعدم قدرة
            البنكرياس علي افراز الأنسولين؟ ولماذا عند البحث عن أسباب امراض القلب
            تظهر نتائج غير محكومة مثل تقدم السن والعصبية، بنفس الوقت الذي ان
            بحثت به حول آلية عمل الجهاز الدوري والقلب والشرايين نكتشف ان هناك
            أدوار أساسية تلعبها مختلف المعادن مثل المغنيسيوم المسؤول عن الحركة
            الانبساطية للقلب وارتخاء الأوعية الدموية والشرايين لضبط الضغط
            المرتفع، والكالسيوم والبوتاسيوم المسؤولين أيضا علي العديد من المهام
            مثل ضبط الحركة الإنقباضية للقلب وتوازن الأملاح والتخفيف من آثار
            الصوديوم، وعند البحث عن اعراض تلك العناصر تظهر امامك مباشرة أعراض
            امراض القلب او ضغط الدم؟ والعديد من الأسئلة حول ذلك الفكر المثير
            للريبة.
          </p>
          <p>
            فلقد خدعنا المنهج الطبي الحديث او ما سنطلق عليه المنهج التقليدي،
            بتوجيه أعيننا وأعين الأطباء للنظر إلى كل عضو على حدة، لنخرج من فكرة
            النظام الكامل للجسم البشري وتتوجه انظارنا لكل عضو بمفرده لنعجز عن
            رؤية كامل المشهد حتي نستطيع ان نستنتج السبب الحقيقي المؤثر علي هذا
            العضو المصاب والذي غاليا ما يكون خارج الدائرة التي تم تسليط الضوء
            عليها فقط لتوجيه اعيننا لها دون باقي الصورة، لتقتصر حلول هذا المنهج
            علي العقاقير الكيميائية لعدم قدرتهم علي استغلال الإمكانيات الجبارة
            للجسم البشري وقدرته المذهلة على الشفاء الذاتي وإصلاح نفسه لتثبيت
            الكذبة بعقولنا والتي تدعي ان المرض المزمن لا يُعالج.
          </p>
          <h2 className="secondary">مؤامرة البيج فارما</h2>
          <p>
            ولتعرف السر عليك فقط بالنظر لتلك المفاجئة، فقط خلال عام 2022 كان
            هناك أكثر من 16 مليون مريض يخضعون للعلاج الكيماوي يوميا بجرعة يصل
            متوسط سعرها الي ألف دولار، أي أرباح تتخطي ال 16 مليار دولار يومياً
            لمرض واحد. فعندما نتساءل عن صاحب المصلحة في انتشار ذلك الفكر
            وتثبيتها بيننا كأمر واقع فإننا نتحدث عن قوة خفية تتحكم بتجارة عالمية
            عملاقة، تجارة هدفها ان تبيع لك ما يضمن لها ان تظل عميل لديها مدي
            الحياة حتي وان كانوا علي دراية بالحل الحقيقي.
          </p>
          <div className="block-2">
            <div className="b-1">
              <p>
                أغرقوا الأطباء بتفاصيل أكثر حول تخصصهم ليتمكنوا من ادارة المرض
                بالعقاقير التي سيوفرونها، ولكن هل يمكن ان تساعد تلك التفاصيل
                والعقاقير الجديدة بمعالجة المرض مع تجاهل السبب الحقيقي ومنبع
                المرض؟ أم ان الأمر برمته سببا للتشتيت وفرصة توسع بمنتجاتهم؟
              </p>
              <p>
                ولقد اثبتت الأبحاث المستقلة التي لا تخضع لرعاية شركات الأدوية
                أنه لا يوجد ما يسمى بمرض مزمن. وانه فقط بمعالجة السبب الجذري
                للمرض، يمكن للجسم العودة إلى حالته الطبيعية والوقاية من المرض
                بشكل فعال. وبالطبع هذه الحقائق ليست في مصلحة شركات الأدوية التي
                تفضل استمرار المرض لضمان عملاء دائمين.
              </p>
              <p>
                لذلك، يجب التحرر من الأفكار الغبية التي اثبتت فشلها، واتباع فكر
                مختلف مبني علي العلم والمعرفة والبراهين ونهج شامل يعالج الجذور
                الحقيقية للمشاكل الصحية لعلاج الامراض المزمنة بشكل دائم وبالطبع
                الوقاية الفعالة منها.
              </p>
            </div>
            <div className="b-2">
              <img src={B1Img2} alt="img" />
            </div>
          </div>
          <h3 className="secondary">مخطط مافيا الصناعات الدوائية العالمية</h3>
          <p>
            والآن قد علمنا الدافع الذي سيطر علي صناعة الأدوية والمصالح المتحالفة
            معها لتنحرف عن مسارها وتسعى جاهدة لإبقاء الناس مرضى ومعتمدين على
            الأدوية. فنموذج أعمالهم يزدهر من خلال ضمان تدفق مستمر من مرضى
            الأمراض المزمنة لاستعبادهم بالحلول المؤقتة. وبدلاً من تقديم الحل
            الحقيقي، ينصب تركيزهم على إدارة الأعراض والحفاظ على حالة من المرض
            المستمر. وينشرون رواية مفادها أن الأمراض المزمنة غير قابلة للشفاء
            وتتطلب العلاج مدى الحياة. يضمن هذا النهج وجود سوق أسير لأدويتهم، مما
            يولد تدفقات من الأرباح الهائلة يوميا تتخطي ميزانية دول.
          </p>
          <p>
            يمارسون ضغوطهم وتوجيهاتهم على التعليم الطبي والأبحاث ويشكلون المناهج
            الدراسية بأسلوب ناعم وخبيث، فتجدهم يمولون الدراسات التي تتماشى مع
            اهتماماتهم، ووقف التمويلات عن الأبحاث التي تتعارض معهم وتقدم حلولا
            حقيقية، مما يحافظ على احتكارهم للمعلومات والحلول الطبية المختلفة
            والتحكم فيما يُعلن عنه وما يتم التكتم عليه.
          </p>
          <p>
            مخطط قديم ليضمنوا أنك ستصبح عميل لهم، وان كنت تختلف معي فاذكر لي أحد
            حولك لم يصبح عميل لهم من قبل! وان عجزت عن الرد فإليك بتحليل الخطة
            الخبيثة والطريق الذي سلكوه.
          </p>
          <h5 className="secondary">أركان المؤامرة</h5>
          <ul>
            <li>
              <h3>1- تشويه التعليم الطبي</h3>
              <p>
                بدأت تلك المافيا اولي خطواتها لتنفيذ ذلك المخطط بتغيير النموذج
                الطبي الأصلي. شوهوا واحتكروا الأبحاث الطبية وسيطروا على تدفق
                المعلومات، وأعادوا كتابة المناهج التعليمية بالأبحاث التي مولوها
                لإعطاء الأولوية للنموذج القائم على الأدوية والعقاقير الكيميائية
                لتلبية حاجة الجسم لما لم يصبح قادرا علي انتاجه او استخدامه،
                متغاضين عن قدرات الشفاء الفطرية للجسم وقانون السببية الذ يحكم
                كامل كوننا.
              </p>
              <p>
                وكان تأثيرهم هائلًا، فانحرفت أنظمة التعليم الطبي لتشجيع النهج
                القائم على علاج الأعراض بدلاً من معالجة الأسباب الجذرية للأمراض.
                تم تهميش المنهجيات الشاملة والوقائية تحت مسمّي "الطب البديل"
                ونشروا العديد من النسخ المشوهة له لزرع فكرة انه ذو تأثير ضعيف
                علي الرغم من أنه هو "الطب الأصلي" الذي أثبت فعاليته لآلاف
                السنين، بينما احتل نموذج إدارة الأمراض القائم على الربح مركز
                الصدارة. ونتيجة لذلك، تم تدريب أجيال من المهنيين الطبيين على
                الاعتماد بشكل كبير على التدخلات الصيدلانية عبر تضليلهم بمعلومات
                وابحاث طبية تتماشي مع مصالحهم واخفاؤهم لأي نتائج أخري. مما خلق
                حالة من احتكار المعلومات حتي الطبيب بها لا يري سوي جزء ضئيل من
                الصورة.
              </p>
            </li>
            <li>
              <h3>2- التعديل الوراثي للمحاصيل</h3>
              <p>
                أدرك أصحاب المصالح الخاصة أهمية العناصر الدقيقة مثل المعادن
                والفيتامينات لجسم الإنسان، والتي يكمن نقصانها كالسر الخفي وراء
                العديد من الأمراض. فبدأوا باتخاذ اولي خطوات التعديل الوراثي علي
                كامل مصادر طعامنا اليومي والتشجيع عليه تحت شعار انها ستزيد
                الانتاج لتلبي حجم الطلب المتزايد، ولكنه بالحقيقة تسبب بانخفاض
                حاد لتركيز المعادن والفيتامينات والعناصر الأساسية والتي تمثل
                القيمة الحقيقية لأي طعام. وبالمقابل زاد محتواه من السعرات
                الحرارية ومواد لم تكن موجودة في النسخ الأصلية مثل الجلوتين
                والفايتيك أسيد اللذان يمنعان الجسم من امتصاص حتي الكميات الضئيلة
                المتبقية، هذا بالإضافة الي تسببهم بامتلاء المحاصيل بمخلفات
                الهرمونات والأسمدة والكيماويات والمبيدات. فربما عزز هذا الترقيع
                الجيني إنتاجية المحاصيل، لكنه جرد الأطعمة من القيمة الغذائية
                الحقيقية التي تحتاجها أجسامنا وزاد من محتوي السعرات بداخلها
                لحصار الفئة القليلة التي علمت الحقيقة بين خيارين، السمنة أو
                المرض، وبالطبع كلاهما واحد.
              </p>
              <p>
                وبتلك الطريقة ضمنوا ان جسمك سيفتقر حتما لاحد تلك العناصر الهامة
                لتخطوا اولي خطواتك نحو المرض. فالموضوع أصبح مسألة وقت حتي يستنزف
                الجسم مخزونه من العناصر التي يحتاجها لتصبح عميل دائم لهم. هكذا
                جروا رجلك دون ان تدري.
              </p>
            </li>
            <li>
              <h3>3- انتشار الأغذية المكررة</h3>
              <p>
                لا تتعجب عندما تجد ان كامل أركان الخطة تلك تمت بشكل متزامن،
                فالفاعل واحد وستكتشف الحقيقة بنفسك الآن.
              </p>
              <p>
                لعب ظهور الأطعمة المصنعة معدومة القيمة الغذائية دورًا رئيسيًا في
                انتشار سوء التغذية على نطاق واسع في المجتمعات الحديثة وبدلا من
                ان تتم مواجهتها نجد انها تحولت لسلع استراتيجية لا تخلو من أي
                منزل. ولكن لماذا كل تلك المساندة، ستعلم الآن. فتلك الأطعمة ليست
                فقط مجردة بشكل كامل من أي قيمة غذائية، فانتشار المواد المكررة
                مثل السكر الأبيض والزيوت المعالجة أدي إلى إغراق نظامنا الغذائي
                بالسعرات الحرارية الفارغة والتي تنهشنا من الداخل لتستنزف ما تبقى
                في أجسامنا من عناصر حيوية.
              </p>
              <p>
                فهذه الأطعمة المصنعة لا تفشل فقط في تغذية الجسم، لكنها تستنزف
                أيضًا احتياطيات العناصر الغذائية القليلة التي استطعنا الحصول
                عليها والموجودة داخل خلايانا. فالجمع بين استهلاك الأطعمة الفقيرة
                بالقيمة الغذائية واستنزاف مخزوننا من العناصر الغذائية يخلق حلقة
                مفرغة من النقص وعدم التوازن، مما يوفر أرضًا خصبة للأمراض
                المزمنة. والتي تجر بعضها بعضاً.
              </p>
              <p>
                علاوة على ذلك، فان الطبيعة الإدمانية لهذه الأطعمة المصنعة، عززت
                لدي الجميع عادة الاستهلاك المفرط وارتفاع معدلات السمنة،
                والاضطرابات الأيضية، والمشاكل الصحية المزمنة الأخرى التي ابتليت
                بها المجتمعات الحديثة.
              </p>
            </li>
            <li>
              <h3>4- تضخم الفجوة بين السعرات الحرارية ومستويات النشاط</h3>
              <p>
                أدت أنماط حياتنا الحديثة إلى تقليل احتياجاتنا اليومية من السعرات
                الحرارية بشكل كبير مقارنة بأسلافنا. فمع الوظائف المكتبية ووسائل
                الراحة، أصبحنا نعيش حياة خاملة لا نبذل فيها الحد الأدنى من
                المجهود البدني الذي خُلقت أجسامنا لتؤديه مقارنة بأجدادنا في
                الماضي الذين كانوا يعيشون على الصيد وجمع الثمار والمهام التي
                كانت تتطلب جهدًا بدنيًا عاليًا، مما كان يساعدهم في حرق كميات
                كبيرة من السعرات الحرارية وتقوية أجسامهم التي تزيد من حرقهم
                للسعرات كلما زادت تلك القوة. ومع ذلك، تبقى احتياجات أجسامنا
                للعناصر الغذائية الدقيقة كالمعادن والفيتامينات ومضادات الأكسدة
                دون نقصان، بل وزاد احتياجنا لها أكثر نتيجة لما استجد بحياتنا من
                عوامل تزيد من استنزافها بالجسم مثل الأطعمة المكررة والتي أحكمت
                العقدة علينا بحصارنا بها.
              </p>
              <div className="block-2">
                <div className="b-1">
                  <p>
                    ومما زاد المشكلة تعقيدًا أن نظامنا الغذائي الحديث أصبح ينقسم
                    لشقين، الأول والذي نعتقد انه الجزء الصحي المتمثل بالخضروات
                    الطازجة المتلاعب بجيناتها والمليئة بالسعرات والألياف
                    والفقيرة بالقيمة الغذائية. أما الجزء الثاني الذ يغطي كامل
                    الفراغ بباقي اليوم من الأطعمة عالية المعالجة وعالية السعرات
                    الحرارية ومعدومة القيمة الغذائية مثل السكر الأبيض والدقيق
                    الأبيض وزيوت القلي والمواد الحافظة التي تقوم بحرق ما تبقي
                    بمخزوننا من المعادن والفيتامينات. ففي حين أننا قد نستهلك
                    سعرات حرارية مفرطة، إلا أنها فشلت في توفير الطاقة التي
                    نحتاجها منها لافتقار الجسم للعناصر التي يحتاجها لحرق تلك
                    السعرات كما انها دخلت بصورة لا يستطيع الجسم سوي تخزينها
                    بالدهون. فأدى هذا التناقض إلى حالة عامة من الإفراط في تناول
                    السعرات الحرارية من جهة ونقص التغذية من الجهة الأخرى، لتتضخم
                    الفجوة المتزايدة بين وارد السعرات والعناصر الغذائية لتمهد
                    أرض خصبة لا تنبت سوي المرض كأمر حتمي.
                  </p>
                </div>
                <div className="b-2">
                  <img src={B1Img3} alt="img" />
                </div>
              </div>
              <p>
                فهذا الخلل بين ميزان السعرات الحرارية والقيمة الغذائية وتضخم
                الفجوة بينهم كان هو النتيجة المطلوبة من الخطوات 2-3-4. وحتي لا
                يقوم أي شخص بكشف حقيقة تلك المؤامرة، كانت تتطلب تلك الخطة إحكام
                خاص وتوسيعه علي نطاق العالم بكامله لضمان عدم انتقال المعلومات
                حول حقيقة تلك الأمراض بين الشعوب وارغامنا علي الاعتراف بالإجماع
                علي وصفها بالأمراض مزمنة وتقبلها كضريبة طبيعية لتقدم العمر. لذا
                كان من الضروري اتخاذ تلك الخطوة الأولي للتحكم بالمعلومات التي
                سوف يتلقاها طبيبك وضمان عدم خروجهم عن النص.
              </p>
              <p>
                ولإحكام قبضتهم علينا ومضاعفة أرباحهم وتوسعهم بأدوية مختلفة
                للعديد من الأمراض المتزايدة، كان لا بد من البدء بتنفيذ خطوتهم
                التالية.
              </p>
            </li>
            <li>
              <h3>5- نشر الخرافات والمفاهيم الخاطئة عن معني التغذية الصحية</h3>
              <p>
                كما ذكرنا كم كانت تلك الخطوة كانت ضرورية لإحكام حصارهم وقبضتهم
                على عقول البشر جميعا لضمان السيطرة الكاملة، وكانت تهدف الي
                استباق الأحداث عبر نشر معلومات محددة وجزء صغير جديد من الصورة
                فقط لنعتمد عليه ويظلوا متمكنين من اخفاء باقي الصورة الكاملة لا
                يخرجون منها الا الاجزاء التي تم حرقها. فأصبح كل من يحاول ان يخرج
                عن القطيع باحثاً عن الحقيقة ومشاكل التغذية، يجد بوجهه ما تم
                زراعته من معلومات قاموا بدسها،
              </p>
              <p>
                فعلي مر السنين قاموا بنشر لعديد من الخرافات والمفاهيم الخاطئة
                حول التغذية كما أخفوا الحقائق التي من شأنها كشف مؤامراتهم، مما
                شوه فهمنا للأكل الصحي وإعاقتنا قدر المستطاع في أي محاولة منا
                للهروب من ذلك الحصار. فتجدهم يخبرونك ان الدهون مادة ضارة دون
                تحديد أي نوع هو الذي يمثل خطورة ومتي يكون ضارا، بالإضافة الي
                خلطهم عمداً بين الدهون والكوليسترول الذي نأكله بهذا الذي يصنعه
                الجسم ونشر الذعر من الكوليسترول علي الرغم أنه من الحقائق التي تم
                اكتشافها ولن يستطيعوا انكارها، أن الجسم إذا حُرم من بعض المواد
                فسوف يقوم بحبسها داخله وهما الماء والدهون والطاقة. وهذا ما نجده
                عندما يقوم الجسم بحبس الماء تحت الجلد كلما حُرم من الماء، كما
                يحتفظ بالوقود الذي يدخله بمخازن الدهون عند اتباع الحميات
                المُعتمدة علي التجويع، وأيضا يقوم بزيادة الدهون الثلاثية بالدم
                عند تجنبك لتناولها عند تجنبك لتناول الدهون الحيوانية. وبنشر تلك
                المعلومات ضمنوا تجنبك من كافة الدهون خوفا، ولكن ما لم تعلمه أن
                ذلك سيكون من الأسباب التي تدفع جسمك للاحتفاظ بها، لتجري وتشتري
                عقار طبي يقوم بخفض الدهون الثلاثية بالدم، مع أن الأمر كان لا
                يتطلب سوي توفريها لجسمك حتي لا يحتفظ بها.
              </p>
              <p>
                وهكذا تتعدد خرافات مثل المبالغة بتقدير البروتين كأهم ما تأكله
                وتجاهلهم للعناصر التي يحتاجها الجسم لامتصاص هذا البروتين
                واستخدامه، ونشر فكرة نجاح نظامك الغذائي وتحسين شكل جسمك يتوقف
                علي عدد السعرات اليومية دون التنبيه علي جودتها، والعديد من
                الخرافات الناتجة عن ها الفكر الساذج والتي بدأت بالدعاية للتبغ
                والكوكايين كعلاج،
              </p>
              <p>
                وآخرها وأخطرهم لسرعة انتشارها كان بعد كورونا وهو تعميم أضرار
                السكر مجاراة للمناخ العام، فبعدما ظهرت الأصوات التي تثبت اضرار
                السكر الأبيض قاموا فورا بإغراق السوشيال ميديا بالمعلومات
                المغلوطة التي تعمم تلك الأضرار علي كامل مصادر الجلوكوز لسحب
                الموجة مرة أخري تجه مصالحهم، هذا بالإضافة الي المغالاة بأهمية
                اتباع الكيتو دايت والأنظمة الغير واقعية حتي تيأس من فكرة
                التغيير. وهكذا قد تمكنوا حتي بحالة انفضاح بعض من خباياهم أن
                يوجهوك بين اختيارين يصبون بمصلحتهم.
              </p>
              <p>
                فكيف تكون جميع الدهون ضارة بصحتنا؟ هذا التبسيط المفرط، الذي
                روجوا، دفع الكثير من الناس إلى تجنب الدهون الصحية مما أدي لحرمان
                الجسم من كل الفيتامينات القابلة للذوبان بالدهون مثل فيتامين أ –
                فيتامين د – فيتامين ه – فيتامين ك، تلك العناصر الضرورية لمختلف
                وظائف الجسم، بما في ذلك صحة الدماغ وتصنيع الهرمونات ونقل المعادن
                من الدم لأماكنها الصحيحة بالجسم وأغشية الخلايا وغيرها الكثير.
                وبدلاً من ذلك، يمنعوك عنها وعندما تمرض تكتشف انها من اهم المواد
                الفعالة بدوائك، كل هذا الحصار فقط ليصيبوك بالمرض ثم ليتحكموا
                بقدر الجرعة التي تحافظ علي حياتك ولا تعالجك وكل هذا علي حسابك
                انت.
              </p>
              <p>
                إن هذا الجنون الذي رعته الشركات العابرة للقارات والمالكة لكل من
                مصانع الأدوية وشركات الأغذية بنفس الوقت، خلق سوقًا ضخمة
                لمحاصرتك، يبيعون لك المرض بيد ثم يبيعون لك العلاج المؤقت بيد
                اخري بينما تظل انت بتلك الحلقة المفرغة بقية حياتك. وهذا ما
                سنحاول تصحيحه بتلك السلسلة، فعدم النظر للصورة كاملة عندما نتحدث
                عن صحة عائلاتنا لا يقل خطورة عن ما كان يحدث، فالنتيجة واحدة، وهي
                تمكنهم من التحكم بحلفائهم ومعارضيهم بآن واحد.
              </p>
              <p>
                لقد حان الوقت للتحرر من هذه الروايات السامة وذلك الفكر الضال
                لنتبني نهج أكثر شمولية وفلسفة قائمة علي فكرة الشفاء العميق.
              </p>
            </li>
          </ul>
          <h2 className="secondary">الأسباب الحقيقية للأمراض المختلفة</h2>
          <p>
            وبعد عقود من البحث والتمحيص بمختلف الجهود الخاصة والمستقلة حول أسباب
            الأمراض المختلفة ودراسة المتغيرات التي طرأت علي علي الحياة الحديثة
            من بعد الثورة الصناعية وتأثيراتها، خلصت جميع الأبحاث الي أن جميع
            الأمراض المزمنة لها جذور مشتركة ويعتبر كل مرض هو فقط مرحلة لمرض اخر،
            والذي يختلف بين مريض سكري ومريض سمنة مفرطة ومريض قلب، فقط ترتيب
            الاصابة والذي لا تتم ملاحظته لثبات المعلومة الاولي بعقولنا اكثر من
            غيره، فعندما تتفاجأ ان احدهم أُصيب بالسكري وشخص آخر أصيب بالسِمنة،
            ستظل تلك هي المعلومة المحفورة بعقلك ولن تقوم بالتركيز حول اي مشكلة
            جديدة تصيبهم مثل المرة الأولي. ولكن بالحقيقة عندما تنظر لهم الآن
            ستكتشف انهم مصابين بنفس المجموعة ولكن مع اختلاف ترتيب الاصابات،
            فالسمنة ستتسبب بالسكري وامراض القلب واللذان يتسببان بهشاشة العظام
            والمياه الزرقاء وما الي اخره، وعلي نفس الدائرة ستجد ان اذا جاء
            السكري بالأول فسوف يتسبب بالسمنة وليس من الشرط ان تكون ظاهرة علي
            الجسم بالخارج ولكن الأخطر هي تلك الدهون التي تحاصر الأحشاء والكبد
            بالإضافة الي الجلطات وامراض القلب وهكذا بالدائرة التي تجر بعضها
            والتي نتجت من الأساس عن أسباب بسيطة ولكنها بسبب اهمالها ظلت تتراكم
            حتي تسببت بكل تلك الفوضى.
          </p>
          <p>
            يمكننا تلخيص الأسباب الجذرية لمعظم الأمراض في خمسة عوامل رئيسية:
          </p>
          <h4 className="secondary">
            العادات الغذائية السيئة – نقصان العناصر الغذائية الدقيقة – البكتيريا
            والجراثيم والفيروسات - السموم – الضغط النفسي والتوتر.
          </h4>
          <p>
            ولكن عند النظر لتلك الأسباب ستكتشف ان جميعهم نتيجة فعل فاعل مخفي
            بينهم وسابق لهم، وبمعالجته، يمكن لأجيالنا القادمة وأولادنا الوقاية
            بشكل من تلك الأمراض المزمنة التي سرقت صحة وحرية أجيالنا، كما يمكن
            أيضا تتبع نفس الجذر واستغلال قدرة الجسم البشري علي الاستشفاء الذاتي
            لعكس الاتجاه نحو الصحة.
          </p>
          <p>
            هذا بالإضافة الي بعض الحالات الناتجة عن اختلال بالإشارات العصبية
            القادمة من المخ للأعضاء المختلفة نتيجة بعض الاصابات بالعمود الفقري
            بمنطقة أعلي من مستوي العضو المصاب.
          </p>
          <p>
            فهل رأيت من قبل طبيب يطلب أشعة علي فقرات مريض السكر، بالطبع لا
            كنتيجة طبيعية لقصر نظر المنهج الذي يتبعوه. حيث تم الاكتشاف بالصدفة
            ان عدد من مرضي السكري من النوع الأول بمجرد ان قاموا بإعادة تقويم
            عمودهم الفقري، استعاد البنكرياس علي الفور قدرته لإنتاج الأنسولين
            كدليل ان سبب تعطله من البداية لم يكن به، وانما كان بسبب انقطاع
            الاشارات الواردة من المخ للبنكرياس بسبب تزحزح فقاري أو انزلاق غضروفي
            بالفقرات الصدرية.
          </p>
          <div className="block-2">
            <div className="b-1">
              <h3 className="secondary">
                العلاج الحقيقي لكافة الأمراض المزمنة
              </h3>
              <p>
                والان بعدما كشفنا ما قادنا اليه النهج الطبي التقليدي، وفهمنا
                أهمية النظر لصحتنا كحلقة كاملة، نجد أن الطريق إلى الشفاء الحقيقي
                وتحسين صحتنا هو حل واقعي ولا يوجد أي تعقيد به، فعلي الرغم من ان
                طريقة تفكيرهم الفاشلة تتعامل مع كل مرض بشكل منفصل وبأدوية متعددة
                لكل حالة وتختلف عن غيرها، إلّا ان الحل الحقيقي لكل مشكلة يرجع
                لمفتاح واحد فقط وسهل التنفيذ.
              </p>
              <p>
                اذا كنت تبحث عن حل واعلاج حقيقي فلا يمكن ان يكون لحالة بعينها
                دون غيرها، فطريق الصحة واحد وهو يتمثل بالرجوع للحالة الفطرية
                للبشرية والتي استمرت معها لآلاف السنين، وبالطبع هنا لا اقصد
                التخلي عن التكنولوجيا التي تتميز بها حضارتنا أو تناول الطعام
                نيئ.
              </p>
              <p>
                ولكن الحل يكمن في تحليل نمط حياتنا وحياة اجدادنا والدمج بين
                مميزاتهم فقط، فنمط حياة اجدادنا كان به الكثير من النشاط والطعام
                كامل القيمة وبالمقابل كان عدد الوجبات اليومية لا يتعدى الوجبتين،
                في حين ان قلة النشاط وكثرة ارتفاعات الانسولين بسبب كثرة الوجبات
                والسناكس بحياتنا والأطعمة المستحدثة ذات المؤشر الجلايسيمي
                المرتفع هما اكبر سبب للسمنة مقاومة الانسولين وأمراض القلب
                والضغط، وبتعزيز النشاط اليومي عبر ممارسة الرياضة والحرص علي
                الامتناع عن المواد الضارة المتكرر استهلاكها واستبدالها بأخري
                مفيدة، نكون بالفعل قد جمعنا بين أفضل ما في حياتنا وحياة اجدادنا
                لنحظى برفاهية الحاضر وصحة الأجداد.
              </p>
            </div>
            <div className="b-2">
              <img src={B1Img4} alt="img" />
            </div>
          </div>
          <p>
            قد يبدو الطريق إلى الشفاء الحقيقي غير تقليدي، لكنه متجذر من المبادئ
            الأساسية لعلم الأحياء وقانون السببية وحكمة اتباع الفطرة. من خلال
            تبني نهج يركز على معالجة الأسباب الجذرية للأمراض، يمكننا إطلاق
            العنان لإمكانات الجسم المذهلة للشفاء الذاتي واستعادة حياتنا النابضة
            بالحياة والخالية من الأمراض.
          </p>
          <p>
            وبدلا من ان اتشعر بأن الحل معقد، عليك ان تعلم انه لا يوجد من سيقدمه
            لك غيرك انت، فانتقل الآن للمقالة التالية لتعرف ان الحل سهل وبسيط جدا
            ولكنه مخفي أمام عينيك بوضوح ولكنك لا تراه.
          </p>
          <p><Link to={""}>انتقل الآن لتراه بعينك</Link></p>
          <img src={B1Img5} alt="img"/>
        </article>
      </main>
      <ShopFooter />
    </div>
  );
};

export default ChronicDiseases;
